<template>
  <div class="main-lab-regist">
    <v-layout xs12 align-center py-3 px-8>
      <v-row align="center">
        <v-col cols="6">
          <h2 class="title">Pendaftaran Laboratorium</h2>
          <h5 class="subtitle caption">
            {{ patientCount }} Pasien terdaftar hari ini
          </h5>
        </v-col>
        <v-col cols="1" class="text-end">
          <v-btn color="grey" icon text @click="getLabRegist">
            <v-icon>mdi-autorenew </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="5">
          <v-text-field
            v-model="filter.search"
            class="input"
            background-color="#FAFAFA"
            placeholder="Cari disini..."
            solo
            dense
            hide-details
            flat
            prepend-inner-icon="mdi-magnify"
            single-line
            @input="debouncedSearch"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-layout>
    <v-divider />
    <v-row no-gutters class="px-8 mt-4">
      <v-col cols="2" class="text-start pe-4">
        <label for="date" class="subtitle-2 mb-4">Tanggal</label>
        <Datepicker
          :clickCloseContent="false"
          :show="menu.date"
          :date="filter.date"
          @date-change="handleDateChange"
        />
      </v-col>
      <v-col cols="2" class="text-start ps-4">
        <label for="date" class="subtitle-2 mb-4">Status Permintaan</label>
        <v-select
          clearable
          dense
          append-icon="mdi-chevron-down"
          :items="items.requestStatus"
          ref="menu"
          v-model="filter.status"
          transition="scale-transition"
          offset-y
          min-width="380px"
          placeholder="Pilih Status"
          outlined
          hide-details="false"
          item-text="label"
          item-value="key"
          @input="
            () => {
              table.pagination.page = 1;
              getLabRegist();
            }
          "
        />
      </v-col>
      <v-col></v-col>
    </v-row>

    <v-layout class="px-8 py-5">
      <v-data-table
        :headers="table.headers"
        :items="labRegistration"
        item-key="orderCode"
        :expanded="expanded"
        single-expand
        hide-default-footer
        class="dataTableStyle"
        :items-per-page="itemsPerRow"
        :height="height"
        :loading="onLoading('tableRegistration')"
      >
        <template v-slot:item="{ item, expand, isExpanded }">
          <tr class="text-left" @click="expand(!isExpanded)">
            <td>
              {{
                (table.pagination.page - 1) * itemsPerRow +
                  labRegistration.indexOf(item) +
                  1
              }}
            </td>
            <td>{{ item.queue }}</td>
            <td>{{ item.noRegistration }}</td>
            <td>
              <p class="ma-0 pa-0">{{ item.orderCode }}</p>
              <v-tooltip bottom v-if="item.orderList.length > 1">
                <template v-slot:activator="{ on, attrs }">
                  <p
                    v-bind="attrs"
                    v-on="on"
                    class="grey--text caption ma-0 pa-0"
                  >
                    +{{ item.orderList.length - 1 }} item lainnya
                  </p>
                </template>
                <div v-bind="attrs" v-on="on">
                  <ul style="text-align: start;">
                    <li
                      class="ma-0 pa-0"
                      v-for="(order, index) in item.orderList.filter(
                        (_, idx) => idx !== 0,
                      )"
                      :key="'order-' + index"
                    >
                      {{ order.order_code }} ({{ order.status }})
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.noRM }}</td>
            <td>
              {{
                item.assurance.slice(0, 1).toUpperCase() +
                  item.assurance.slice(1)
              }}
            </td>
            <td>
              <span
                label
                :class="
                  item.isNew === true
                    ? 'main-lab-regist__chipNew'
                    : 'main-lab-regist__chipOld'
                "
              >
                {{ item.isNew === true ? 'Baru' : 'Lama' }}
              </span>
            </td>
            <td class="py-3">
              <v-chip
                :class="'main-lab-regist__chipStatus ' + item.status"
                label
                :color="getStatus(item.status).color"
              >
                {{ getStatus(item.status).text }}
              </v-chip>
              <v-tooltip bottom v-if="item.orderList.length > 1">
                <template v-slot:activator="{ on, attrs }">
                  <p
                    v-bind="attrs"
                    v-on="on"
                    class="grey--text caption ma-0 pa-0"
                  >
                    +{{ item.orderList.length - 1 }} item lainnya
                  </p>
                </template>
                <div v-bind="attrs" v-on="on">
                  <ul style="text-align: start;">
                    <li
                      class="ma-0 pa-0"
                      v-for="(order, index) in item.orderList.filter(
                        (_, idx) => idx !== 0,
                      )"
                      :key="'order-' + index"
                    >
                      {{ order.order_code }} ({{ order.status }})
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" class="p-0" style="color: #616161;">
            Tidak ada pasien yang terdaftar
          </v-alert>
        </template>
        <template v-slot:expanded-item="{ item, index, headers }">
          <td :colspan="headers.length" class="my-border">
            <v-card flat>
              <v-row no-gutters style=" padding: 1rem 0rem;">
                <v-col cols="1" style="max-width: 13%;"></v-col>
                <v-col
                  cols="4"
                  class="text-left grey--text caption"
                  style="max-width: 27.5%"
                >
                  <span
                    >Terdaftar
                    {{ formatDate(item?.timestamps?.createdAt, false) }} WIB
                    {{ formatDate(item?.timestamps?.createdAt, true) }}</span
                  ></v-col
                >
                <v-col
                  cols="3"
                  class="text-left grey--text caption"
                  style="max-width: 26%"
                >
                  <span
                    >{{ item?.gender === true ? 'Laki - Laki' : 'Perempuan' }}
                    {{ item?.ageFormatted }}</span
                  ></v-col
                >
              </v-row>
            </v-card>

            <v-card flat color="grey lighten-4" class="text-right">
              <v-container>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          icon
                          class="mx-2 hover"
                          v-on="{ ...tooltip }"
                          @click="onClicked(2, item)"
                        >
                          <font-awesome-icon icon="user" />
                        </v-btn>
                      </template>
                      <span>Data Sosial</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="mx-2 hover"
                          v-bind="attrs"
                          v-on="on"
                          @click="onClicked(6, item, index)"
                        >
                          <font-awesome-icon icon="flask" />
                        </v-btn>
                      </template>
                      <span>Pemeriksaan Laboratorium</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          icon
                          class="mx-2 hover"
                          v-on="{ ...tooltip }"
                          @click="onClicked(4, item)"
                        >
                          <v-icon size="21" style="padding-top: 2px"
                            >mdi-printer</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Print Dokumen</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="mx-2 hover"
                          v-bind="attrs"
                          v-on="on"
                          @click="deleteRegistLab(item)"
                          v-if="!item.isFinish"
                          :disabled="item.status !== 'unprocess'"
                        >
                          <v-icon color="red" size="21" style="padding-top: 2px"
                            >mdi-close-thick</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Hapus</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-layout>

    <v-dialog
      v-model="showDialog"
      :max-width="selectedForm === null ? 0 : widthDialog[selectedForm].width"
      persistent
      :fullscreen="selectedForm === 3 || selectedForm === 6"
    >
      <OldNewDialog
        v-if="selectedForm === 0 && showDialog"
        @on-clicked="getData"
        @close-form="closeShowDialog"
        @to-regist="onClicked(2)"
      />
      <SearchDataPatient
        v-else-if="selectedForm === 5 && showDialog"
        @close-form="closeShowDialog"
        @on-clicked="getData"
        @back="
          selectedForm = 0;
          searchPatient = '';
        "
        @to-regist="
          patientSelected = null;
          onClicked(2);
        "
      />
      <ExaminationDialogV2
        confirmationState="register"
        v-if="selectedForm === 1"
        @close-dialog="selectedForm = 0"
        @open-history-lab-order="selectedForm = 6"
      />
      <SocialDataPatients
        v-if="selectedForm === 2 && showDialog"
        @close-form="closeShowDialog"
        :medical-record="selectedPatient.rmNumber"
        updatedFrom="laboratorium-social-data"
      />
      <LabRequest
        v-else-if="selectedForm === 3 && showDialog"
        @close-dialog="closeShowDialog"
        :activityStatus="'detail-register'"
        :patient-data="selectedPatient"
        confirmationState="register"
      />
      <PrintDialog
        :hasGeneralConsent="selectedPatient.hasGeneralConsent"
        v-else-if="selectedForm === 4 && showDialog"
        @close-form="closeShowDialog"
        :selected-patient="selectedPatient"
        state="laboratorium"
      />
      <examination-order-history
        v-else-if="selectedForm === 6 && showDialog"
        @close-dialog="closeShowDialog"
        unit="Laboratorium"
      />
    </v-dialog>

    <v-snackbar
      absolute
      light
      content-class="font-weight-medium pr-0"
      :value="snackbar.show"
      elevation="0"
      :color="snackbar.color"
      height="15"
    >
      <div class="d-flex justify-space-between align-center">
        <span style="color: white">
          {{ snackbar.text }}
        </span>
        <v-btn
          style="color: white"
          text
          fab
          small
          right
          @click="snackbar.show = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
    </v-snackbar>

    <v-footer color="white">
      <v-row align="center">
        <v-pagination
          v-model="table.pagination.page"
          :length="table.pageLength"
          total-visible="5"
          @input="getLabRegist()"
        />
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-6"
          fab
          dark
          @click="onClicked(0)"
          elevation="0"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
const _ = require('lodash');
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import { createNamespacedHelpers } from 'vuex';
import OldNewDialog from './components/OldNewDialogV2.vue';
import SocialDataPatients from '../SharedComponent/SocialData.vue';
import PrintDialog from './components/PrintDialog.vue';
import LabRequest from '../Laboratorium/components/ExaminationOrder/ExaminationDialogV2.vue';
import ExaminationDialogV2 from '../Laboratorium/components/ExaminationOrder/ExaminationDialogV2.vue';
import ExaminationOrderHistory from '../Laboratorium/components/ExaminationOrder/ExaminationOrderHistory.vue';
import SearchDataPatient from './components/SearchDataPatient.vue';
import Datepicker from '@/components/SharedComponent/Datepicker/Datepicker.vue';
import { deletePatientRegistration } from '@/fetchApi/Registration';
import { deleteRegisterLab } from '@/fetchApi/laboratory';

const {
  mapGetters: labGetters,
  mapActions: labActions,
  mapMutations: labMutations,
} = createNamespacedHelpers('ExaminationLaboratory');
const { mapMutations: patientMutations } = createNamespacedHelpers(
  'PatientRegistration',
);

export default {
  name: 'LaboratoriumRegist',
  components: {
    OldNewDialog,
    SocialDataPatients,
    ExaminationDialogV2,
    LabRequest,
    PrintDialog,
    SearchDataPatient,
    Datepicker,
    ExaminationOrderHistory,
  },
  computed: {
    ...labGetters([
      'getLabRegistration',
      'getIsLoading',
      'getShowDialog',
      'getSnackbar',
    ]),
    labRegistration: {
      get() {
        return this.getLabRegistration;
      },
    },
    filterDate: {
      get() {
        return this.filter.date !== ''
          ? moment(this.filter.date).format('L')
          : '';
      },
      set(val) {
        if (val === null) {
          this.filter.date = moment(new Date()).format('YYYY-MM-DD');
          this.getLabRegist();
        }
      },
    },
    snackbar: {
      get() {
        return this.getSnackbar;
      },
    },
    showDialog: {
      get() {
        return this.getShowDialog;
      },
      set(val) {
        this.setShowDialog(val);
      },
    },
    itemsPerRow() {
      let itemRow = '';
      switch (this.$vuetify.breakpoint.name) {
        case 'xs' || 'sm' || 'md':
          itemRow = 5;
          break;
        case 'lg':
          itemRow = 7;
          break;
        case 'xl':
          itemRow = 12;
          break;
        default:
          return 5;
      }
      return itemRow;
    },
    height() {
      let height = 0;
      switch (this.$vuetify.breakpoint.name) {
        case 'md':
          height = '51vh';
          break;
        case 'lg':
          height = '54vh';
          break;
        case 'xl':
          height = '61vh';
          break;
      }
      return height;
    },
  },
  methods: {
    ...labActions(['resolveGetLabRegistration', 'resolveDeleteRegisterLab']),
    ...labMutations([
      'setIsRegistration',
      'setShowDialog',
      'setSelectedPatientIndex',
      'setPatientData',
      'clearState',
      'setStateRegistration',
      'setSnackbar',
    ]),
    ...patientMutations([
      'setPatientRegistration',
      'clearStatePatientRegistration',
    ]),
    handleDateChange(updatedDate) {
      this.filter.date = updatedDate;
      this.table.pagination.page = 1;
      this.getLabRegist();
    },
    formatDate(val, isDate = false) {
      if (isDate) {
        return moment(val)
          .locale('id')
          .format('LL');
      } else {
        return moment(val)
          .locale('id')
          .format('LT');
      }
    },
    closeShowDialog() {
      this.setShowDialog(false);
    },
    deleteRegistLab(item) {
      const isMultiOrder = item.orderList.length > 1;
      const textCondition = !isMultiOrder
        ? '<p>Jika Anda batalkan, permintaan ini akan dihapus</p><p>dan pendaftaran laboratorium pasien juga akan</p><p>dibatalkan</p>'
        : '<p>Permintaan yang Anda batalkan akan dihapus</p>';
      Swal.fire({
        title:
          '<label style="font-weight: 600; font-family: Roboto; font-size: 18px; color: #222222; line-height: 150%;">Apakah Anda ingin membatalkan permintaan ini?</label>',
        html: `<div style="text-transform: none; font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%;">${textCondition}</div>`,
        iconHtml: '<span class="mdi mdi-help-circle-outline"></span>',
        showCancelButton: true,
        customClass: {
          confirmButton: 'button-confirm',
          cancelButton: 'button-cancel',
        },
        confirmButtonText: 'Yakin',
        cancelButtonText: 'Batal',
        reverseButtons: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            if (!isMultiOrder) {
              await deletePatientRegistration(item.idRegistration);
              this.setSnackbar({
                show: true,
                color: 'success',
                text: 'Permintaan dan registrasi pasien berhasil dibatalkan',
              });
              setTimeout(() => {
                this.setSnackbar({
                  show: false,
                  color: 'success',
                  text: '',
                });
              }, 3000);
            } else {
              await deleteRegisterLab(item.idLab);
              this.setSnackbar({
                show: true,
                color: 'success',
                text: 'Permintaan berhasil dibatalkan',
              });
              setTimeout(() => {
                this.setSnackbar({
                  show: false,
                  color: 'success',
                  text: '',
                });
              }, 3000);
            }
          } finally {
            this.getLabRegist();
          }
        }
      });
    },
    onClicked(val, item = null, index) {
      if (val === 0) {
        this.setIsRegistration(true);
      }
      this.selectedPatient = {
        rmNumber: item?.noRM,
        id_registration: item?.idRegistration,
        idEMR: item?.idEMR,
        meta: {
          name: item?.name,
          age: item?.age,
          birthDateUnformatted: item?.birthDate,
          gender: item?.gender,
          birthDate: item?.birthDate,
          polyName: item?.polyName,
          doctor: '',
        },
        queue: item?.queue,
        noRegist: item?.noRegistration,
        hasGeneralConsent: item?.hasGeneralConsent,
        guarantorType: item?.guarantorType,
      };
      this.$store.commit('changeSelectedPatient', this.selectedPatient);
      this.setPatientData({
        id_registration: item?.idRegistration,
        id_emr: item?.idEMR,
      });
      this.setSelectedPatientIndex(index);
      this.statusLab = item?.status;
      this.selectedForm = val;
      this.setShowDialog(true);
    },
    getStatus(status) {
      switch (status) {
        case 'unprocess':
          return { color: '#FFF2F2', text: 'Belum Diproses' };
        case 'inprocess':
          return { color: '#FFF9E5', text: 'Sedang Diproses' };
        case 'finish':
          return { color: '#E5FFF0', text: 'Selesai Diproses' };
      }
    },
    onLoading(val) {
      return this.getIsLoading(val);
    },
    getData(val) {
      if (val === null) {
        this.setPatientRegistration({ label: 'rmNumber', value: '' });
        this.setPatientRegistration({ label: 'statusIsNew', value: true });
        this.onClicked(1);
      } else {
        this.setPatientRegistration({ label: 'rmNumber', value: val });
        this.setPatientRegistration({ label: 'statusIsNew', value: false });
        if (val !== null && this.selectedForm === 5) {
          this.onClicked(1);
        } else {
          this.onClicked(5);
        }
      }
    },
    getLabRegist() {
      const itemCount = this.itemsPerRow;
      this.resolveGetLabRegistration({
        search: this.filter.search,
        date: this.filter.date,
        status: this.filter.status,
        page: this.table.pagination.page,
        itemCount: itemCount,
      }).then(page => {
        this.table.pageLength = Math.ceil(page / itemCount);
        this.menu.date = false;
        this.patientCount = page || 0;
      });
    },
    debouncedSearch: _.debounce(function() {
      this.table.pagination.page = 1;
      this.getLabRegist();
    }, 700),
    setDefaultDate() {
      if (this.filter.date === '') {
        this.filter.date = moment().format('YYYY-MM-DD'); // format the current date as a string
      }
    },
  },
  mounted() {
    this.setDefaultDate();
    this.getLabRegist();
  },
  watch: {
    showDialog: {
      handler() {
        if (this.showDialog === false) {
          this.setIsRegistration(false);
          this.getLabRegist();
          this.clearStatePatientRegistration();
          this.clearState();
        }
      },
      deep: true,
    },
    'filter.status': {
      handler(newValue) {
        if (!newValue) {
          this.filter.status = '';
          this.getLabRegist();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      patientCount: 0,
      date: null,
      dialog: false,
      selectedForm: null,
      generalConsentPatient: false,
      widthDialog: [
        { text: 'OldNewPatient', width: 600 },
        { text: 'SocialDataPatientsLaboratory', width: 1400 },
        { text: 'SocialDataPatients', width: 1200 },
        { text: 'LabRequest', width: 1200 },
        { text: 'PrintDocuments', width: 346 },
        { text: 'SearchDataPatient', width: 1200 },
        { text: 'OrderHistory', width: 1200 },
      ],
      menu: {
        date: false,
      },
      expanded: [],
      items: {
        requestStatus: [
          { label: 'Belum Diproses', key: 'Unprocess' },
          { label: 'Sedang Diproses', key: 'Inprocess' },
          { label: 'Selesai Diproses', key: 'Finish' },
        ],
      },
      filter: {
        date: '',
        search: '',
        status: '',
      },
      selectedPatient: {
        rmNumber: '',
        idRegistration: '',
      },
      statusLab: '',
      table: {
        headers: [
          { text: 'No.', value: 'no', sortable: false },
          { text: 'No. Antrean', value: 'queue', sortable: false },
          { text: 'No. Registrasi', value: 'noRegistration', sortable: false },
          { text: 'No. Order', value: 'orderCode', sortable: false },
          { text: 'Nama', value: 'name', sortable: false },
          { text: 'No. RM', value: 'noRM', sortable: false },
          { text: 'Tipe Penjamin', value: 'assurance', sortable: false },
          { text: 'Jenis Pasien', value: 'isNew', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
        ],
        pagination: {
          page: 1,
        },
        pageLength: 1,
      },
    };
  },
};
</script>

<style lang="scss">
.button-confirm {
  background-color: #137bc0 !important;
  border-radius: 4px !important;
}
.button-cancel {
  background-color: white !important;
  border: 1px solid #137bc0 !important;
  border-radius: 4px !important;
  color: #137bc0 !important;
}
.swal2-icon {
  border-color: rgba(156, 162, 165, 0.2) !important;
}
.swal2-icon .swal2-icon-content {
  color: #9ca2a5 !important;
}
.main-lab-regist {
  font-family: 'Roboto';
  position: relative;
  .title {
    text-align: left;
    font-weight: bold !important;
    padding-bottom: 0 !important;
  }
  .subtitle {
    text-align: left;
    color: #adb5bd !important;
    font-weight: 500;
  }

  &__chipOld {
    color: #2f80ed;
    background-color: #f0f9ff;
    border-radius: 4px;
    padding: 6px 8px;
  }

  &__chipNew {
    color: #e5a82e;
    background-color: #fff9e5;
    border-radius: 4px;
    padding: 6px 8px;
  }

  .main-lab-regist__chipStatus.unprocess {
    color: #eb4747;
  }

  .main-lab-regist__chipStatus.inprocess {
    color: #e5a82e;
  }

  .main-lab-regist__chipStatus.finish {
    color: #2d965a;
  }

  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.dataTableStyle {
  width: 100%;
  ::v-deep .v-data-table-header {
    tr {
      background-color: #fafafa;
      th {
        color: #9e9e9e !important;
      }
    }
  }
}
</style>
